export const GET_CONDO_DETAILS = 'getCondoDetail';
